module.exports = __webpack_public_path__ + "media/img/clients-modal/bit4coin-20e5bf610f7cc3074df552907c4656ff.svg";